import { render, staticRenderFns } from "./PartnerSelection.vue?vue&type=template&id=3afb46a4&scoped=true"
import script from "./PartnerSelection.vue?vue&type=script&lang=js"
export * from "./PartnerSelection.vue?vue&type=script&lang=js"
import style0 from "./PartnerSelection.vue?vue&type=style&index=0&id=3afb46a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afb46a4",
  null
  
)

export default component.exports